export function simboloMoedaPorIdioma(lang: string | null | undefined): string {
  const code = (lang || 'pt').toLowerCase();
  return code === 'pt' || code.startsWith('pt-') ? 'R$' : '$';
}

export function formatarMoedaPorIdioma(
  valor: number | string | null | undefined,
  lang: string | null | undefined,
  locale?: string
): string {
  const numero = Number(valor);
  const seguro = Number.isFinite(numero) ? numero : 0;

  if (simboloMoedaPorIdioma(lang) === 'R$') {
    return seguro.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  const formatado = seguro.toLocaleString(locale || 'en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `$${formatado}`;
}
